export default "__VITE_ASSET__BaGTyjzz__"